import { c as _c } from "react/compiler-runtime";
import type { MissionListItem } from '@module/apis/client-side/mission/type';
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import { aspCond } from '@module/helpers/conditions/condition';
import { cn } from '@module/lib/utils';
import { useAddMissionHeartMutation } from '@module/queries/mission/missionQueryHooks';
import { missionListQueryKeys } from '@module/queries/mission/missionQuerykeys';
import useModalStore from '@module/stores/useModalStore';
import { CloseFill } from '@module/svg/icons';
import { BaseHttpResponseError } from '@module/utils/error/apiErrors';
import formatNumberWithComma from '@module/utils/formatNumberWithComma';
import ToastBody from '@pc/components/atoms/toast/ToastBody';
import ModalFooter from '@pc/components/modal/ModalFooter';
import { Modal } from '@pc/components/modal/modal';
import { useQueryClient } from '@tanstack/react-query';
import { useRef, useState } from 'react';
import toast, { type Toast } from 'react-hot-toast';
export default function ModalMissionSupport(t0) {
  const $ = _c(65);
  const {
    item
  } = t0;
  const [isFocus, setIsFocus] = useState(false);
  const ref = useRef(null);
  const queryClient = useQueryClient();
  const [count, setCount] = useState("");
  const [error, setError] = useState("");
  const pushModal = useModalStore(_temp);
  const popModal = useModalStore(_temp2);
  const {
    userInfo
  } = useGetLoginInfoQuery();
  let t1;
  if ($[0] !== popModal || $[1] !== queryClient) {
    t1 = () => {
      queryClient.invalidateQueries({
        queryKey: missionListQueryKeys._def,
        exact: false
      });
      toast(_temp3);
      popModal();
    };
    $[0] = popModal;
    $[1] = queryClient;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== pushModal || $[4] !== queryClient) {
    t2 = err => {
      queryClient.invalidateQueries({
        queryKey: missionListQueryKeys._def,
        exact: false
      });
      if (err instanceof BaseHttpResponseError) {
        pushModal({
          type: "CONFIRM_MODAL",
          id: "ModalMissionSupport",
          options: {
            description: err.serverResponse.message
          }
        });
      } else {
        toast(_temp4);
      }
    };
    $[3] = pushModal;
    $[4] = queryClient;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = {
      onSuccess: t1,
      onError: t2
    };
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const {
    mutate: addMissionHeart,
    isPending
  } = useAddMissionHeartMutation(t3);
  let t4;
  if ($[9] !== count || $[10] !== userInfo) {
    t4 = () => {
      if (Number(count) <= 0) {
        setError("\uD558\uD2B8\uC120\uBB3C\uAC1C\uC218\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694.");
        return false;
      }
      if (!userInfo?.coinHave || Number(count) > userInfo.coinHave) {
        setError(aspCond.if("iframe-asp") ? "\uBCF4\uC720 \uD558\uD2B8\uAC00 \uBD80\uC871\uD569\uB2C8\uB2E4.\n\uD558\uD2B8\uB97C \uCDA9\uC804\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?" : "\uBCF4\uC720\uD55C \uD558\uD2B8\uAC00 \uBD80\uC871\uD569\uB2C8\uB2E4. \uCDA9\uC804 \uD6C4 \uC774\uC6A9\uD574 \uC8FC\uC138\uC694.");
        return false;
      }
      return true;
    };
    $[9] = count;
    $[10] = userInfo;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const validation = t4;
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = text => {
      let onlyNumbers = text.replace(/[^0-9]/g, "");
      if (onlyNumbers.length > 1 && onlyNumbers.startsWith("0")) {
        onlyNumbers = onlyNumbers.substring(1);
      }
      const numValue = Number(onlyNumbers);
      if (numValue > 999999999) {
        onlyNumbers = "999999999";
      }
      setError("");
      setCount(onlyNumbers);
    };
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const onChangeHandler = t5;
  const t6 = Number(count) || 0;
  let t7;
  if ($[13] !== item.idx || $[14] !== t6) {
    t7 = {
      missionIdx: item.idx,
      coin: t6
    };
    $[13] = item.idx;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const params = t7;
  let t8;
  if ($[16] !== addMissionHeart || $[17] !== isPending || $[18] !== params || $[19] !== validation) {
    t8 = async () => {
      if (!validation()) {
        return;
      }
      if (isPending) {
        return;
      }
      addMissionHeart(params);
    };
    $[16] = addMissionHeart;
    $[17] = isPending;
    $[18] = params;
    $[19] = validation;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const onSubmitHandler = t8;
  let t9;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Modal.Header><Modal.Title>추가 후원</Modal.Title></Modal.Header>;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== item.title) {
    t10 = <div className="h-[72px] rounded-lg border border-borderBg03 bg-colorBg24 px-4 py-[18px] text-[16px] text-colorFg23 leading-[1.38]">{item.title}</div>;
    $[22] = item.title;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span>보유하트</span>;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  const t12 = userInfo?.coinHave;
  let t13;
  if ($[25] !== t12) {
    t13 = formatNumberWithComma(t12);
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13) {
    t14 = <div className="mt-6 flex h-10 items-center justify-between rounded-[5px] bg-colorBg16 px-[14px] text-[#222] text-[15px]">{t11}<span>{t13} 개</span></div>;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  const t15 = error && "border-colorRed";
  const t16 = !error && isFocus && "border-tertiary";
  let t17;
  if ($[29] !== t15 || $[30] !== t16) {
    t17 = cn("relative mb-[5px] flex h-[40px] w-full items-center border-borderBg03 border-b-2 transition-colors", t15, t16);
    $[29] = t15;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  const t18 = error && "text-colorRed";
  const t19 = !error && isFocus && "text-tertiary";
  let t20;
  if ($[32] !== t18 || $[33] !== t19) {
    t20 = cn("pointer-events-none absolute top-[10px] left-0 z-[1] text-colorFg06 text-sm", t18, t19);
    $[32] = t18;
    $[33] = t19;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t20) {
    t21 = <div className={t20}>하트선물개수</div>;
    $[35] = t20;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  let t23;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = () => setIsFocus(true);
    t23 = () => setIsFocus(false);
    $[37] = t22;
    $[38] = t23;
  } else {
    t22 = $[37];
    t23 = $[38];
  }
  let t24;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = e => onChangeHandler(e.target.value);
    $[39] = t24;
  } else {
    t24 = $[39];
  }
  let t25;
  let t26;
  if ($[40] !== count) {
    t25 = <input ref={ref} value={count} onFocus={t22} onBlur={t23} type="tel" pattern={"\\d*"} className="relative z-[2] min-w-0 flex-[20] border-0 bg-transparent p-0 text-right text-colorFg01 text-sm outline-none" onChange={t24} />;
    t26 = count && <CloseFill style={{
      fontSize: 10
    }} onClick={() => {
      setCount("");
      setError("");
      ref.current?.focus();
    }} className="z-[2] ml-1 shrink-0 cursor-pointer" />;
    $[40] = count;
    $[41] = t25;
    $[42] = t26;
  } else {
    t25 = $[41];
    t26 = $[42];
  }
  let t27;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <span className="z-[1] flex-1 pl-[5px] text-right text-colorFg06 text-sm leading-[46px]">개</span>;
    $[43] = t27;
  } else {
    t27 = $[43];
  }
  let t28;
  if ($[44] !== t17 || $[45] !== t21 || $[46] !== t25 || $[47] !== t26) {
    t28 = <div className={t17}>{t21}{t25}{t26}{t27}</div>;
    $[44] = t17;
    $[45] = t21;
    $[46] = t25;
    $[47] = t26;
    $[48] = t28;
  } else {
    t28 = $[48];
  }
  let t29;
  if ($[49] !== error) {
    t29 = error && <p className="text-left text-[13px] text-colorRed">{error}</p>;
    $[49] = error;
    $[50] = t29;
  } else {
    t29 = $[50];
  }
  let t30;
  if ($[51] !== t28 || $[52] !== t29) {
    t30 = <div className="relative mt-6 text-right transition-all duration-200 ease-in-out">{t28}{t29}</div>;
    $[51] = t28;
    $[52] = t29;
    $[53] = t30;
  } else {
    t30 = $[53];
  }
  let t31;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <div className="mt-6 rounded-md bg-colorBg04 px-6 py-[30px]"><ul className="flex list-none flex-col gap-1 pb-1"><li className={"relative pl-3 text-left text-colorFg09 text-sm tracking-[-1px] before:absolute before:top-[11px] before:left-0 before:size-[2px] before:rounded-full before:bg-[#777] before:content-[\"\"]"}>미션에 대한 추가 후원은 취소할 수 없습니다. 신중하게 결정해 주세요</li><li className={"relative pl-3 text-left text-colorFg09 text-sm tracking-[-1px] before:absolute before:top-[11px] before:left-0 before:size-[2px] before:rounded-full before:bg-[#777] before:content-[\"\"]"}>미션 요청 후 1시간 내에 BJ가 시작하지 않으면 자동으로 취소됩니다.</li><li className={"relative pl-3 text-left text-colorFg09 text-sm tracking-[-1px] before:absolute before:top-[11px] before:left-0 before:size-[2px] before:rounded-full before:bg-[#777] before:content-[\"\"]"}>미션이 성공 또는 취소, 실패한 경우의 하트후원 및 복구 처리는 1분마다 갱신됩니다.(최장 1분소요)</li></ul></div>;
    $[54] = t31;
  } else {
    t31 = $[54];
  }
  let t32;
  if ($[55] !== t10 || $[56] !== t14 || $[57] !== t30) {
    t32 = <Modal.Content className="modal-scrollbar-custom mb-0 h-[calc(100%-135px)] pt-[24px] pb-0"><div className="flex flex-col">{t10}{t14}{t30}{t31}</div></Modal.Content>;
    $[55] = t10;
    $[56] = t14;
    $[57] = t30;
    $[58] = t32;
  } else {
    t32 = $[58];
  }
  let t33;
  if ($[59] !== isPending || $[60] !== onSubmitHandler) {
    t33 = <ModalFooter className="mt-2" close={true} onClick={onSubmitHandler} text={"\uD6C4\uC6D0\uD558\uAE30"} isPending={isPending} />;
    $[59] = isPending;
    $[60] = onSubmitHandler;
    $[61] = t33;
  } else {
    t33 = $[61];
  }
  let t34;
  if ($[62] !== t32 || $[63] !== t33) {
    t34 = <Modal.Container className="h-[600px] w-[368px]">{t9}{t32}{t33}</Modal.Container>;
    $[62] = t32;
    $[63] = t33;
    $[64] = t34;
  } else {
    t34 = $[64];
  }
  return t34;
}
function _temp4(m_0) {
  return <ToastBody id={m_0.id} content={"\uCD94\uAC00\uD6C4\uC6D0 \uB4F1\uB85D\uC2E4\uD328"} />;
}
function _temp3(m) {
  return <ToastBody id={m.id} content={"\uBBF8\uC158 \uCD94\uAC00 \uD6C4\uC6D0\uC774 \uC644\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4."} />;
}
function _temp2(state_0) {
  return state_0.popModal;
}
function _temp(state) {
  return state.pushModal;
}